import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: any[];
  categoryName?: string;
  totalRecords?: number;
}

const initialState: InitialState = {};

const getListEmployeeLeaveRequestSlice = createSlice({
  name: "getListEmployeeLeaveRequest",
  initialState,
  reducers: {
    getListEmployeeLeaveRequestStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListEmployeeLeaveRequestSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
        categoryName?: string;
        totalRecords: number;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
      state.categoryName = action.payload.categoryName;
      state.totalRecords = action.payload.totalRecords;
    },
    getListEmployeeLeaveRequestFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
      state.totalRecords = 0;
    },
    resetListEmployeeLeaveRequest: (state) => initialState,
  },
});

export const {
  getListEmployeeLeaveRequestStart,
  getListEmployeeLeaveRequestSuccess,
  getListEmployeeLeaveRequestFailed,
  resetListEmployeeLeaveRequest,
} = getListEmployeeLeaveRequestSlice.actions;

export default getListEmployeeLeaveRequestSlice.reducer;
